<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="h-screen flex overflow-hidden bg-gray-100">
    <!-- Off-canvas menu for mobile, show/hide based on off-canvas menu state. -->

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex flex-col h-0 flex-1 border-r border-gray-200 bg-white">
          <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav class="mt-5 flex-1 px-2 bg-white space-y-1">
              <!-- Current: "bg-gray-100 text-gray-900", Default: "text-gray-600 hover:bg-gray-50 hover:text-gray-900" -->
              <router-link
                :to="{ name: 'AutomationConfigure' }"
                exact-active-class="bg-gray-100 text-gray-900"
                class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
              >
                Abandoned carts
              </router-link>
              <router-link
                :to="{ name: 'OrderConfirmation' }"
                exact-active-class="bg-gray-100 text-gray-900"
                class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
              >
                Order confirmation
              </router-link>
              <router-link
                :to="{ name: 'OrderShippingUpdates' }"
                exact-active-class="bg-gray-100 text-gray-900"
                class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
              >
                Order Shipping updates
              </router-link>
              <router-link
                :to="{ name: 'CodOrder' }"
                exact-active-class="bg-gray-100 text-gray-900"
                class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
              >
                COD order confirmation
              </router-link>

              <router-link
                :to="{ name: 'MessageLogs' }"
                exact-active-class="bg-gray-100 text-gray-900"
                class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
              >
                <!-- Heroicon name: users -->

                Message logs
              </router-link>
              <router-link
                :to="{ name: 'Faqs' }"
                exact-active-class="bg-gray-100 text-gray-900"
                class=" text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md"
              >
                <!-- Heroicon name: users -->

                Faqs
              </router-link>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
